import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "Le bilan est-il vraiment gratuit ?",
    a: "Le bilan est intégralement financé par votre Compte Personnel de Formation (CPF). Vous ne payez rien de votre poche, à condition que votre solde CPF couvre le coût du bilan (généralement 1 500 € à 2 000 €). Nous vérifions votre éligibilité gratuitement avant tout démarrage.",
  },
  {
    q: "Combien coûte vraiment un bilan de compétences ?",
    a: "Le coût d'un bilan de compétences chez E-forma est de 1 750 € TTC, intégralement pris en charge par votre CPF si votre solde le permet. Vous n'avancez aucun frais. Notre équipe vérifie votre solde et votre éligibilité gratuitement avant tout engagement.",
  },
  {
    q: "Que se passe-t-il si mon solde CPF est insuffisant ?",
    a: "Plusieurs solutions existent : abondement employeur, financement personnel partiel, prise en charge OPCO, ou report du démarrage le temps de cumuler des droits. Nous étudions votre situation et proposons la solution adaptée, sans frais ni engagement.",
  },
  {
    q: "Mon employeur sera-t-il informé de ma démarche ?",
    a: "Non, votre démarche est strictement confidentielle. Le bilan de compétences réalisé sur votre temps libre (en dehors du temps de travail) ne fait l'objet d'aucune communication à votre employeur. Vos données personnelles sont protégées conformément au RGPD.",
  },
  {
    q: "Qu'est-ce qu'un bilan de compétences exactement ?",
    a: "Le bilan de compétences est un dispositif encadré par la loi qui permet d'analyser vos compétences professionnelles et personnelles, vos aptitudes et motivations, afin de définir un projet professionnel réaliste et un plan d'action pour le mettre en œuvre.",
  },
  {
    q: "Comment est financé le bilan de compétences via le CPF ?",
    a: "Votre Compte Personnel de Formation (CPF) peut couvrir l'intégralité du coût de votre bilan de compétences, sans aucune avance de frais de votre part. Nous vous accompagnons dans les démarches administratives.",
  },
  {
    q: "Combien de temps dure un bilan de compétences ?",
    a: "Le bilan se déroule sur une durée totale de 24 heures, réparties sur environ 3 mois. Les séances sont flexibles et s'adaptent à votre emploi du temps.",
  },
  {
    q: "Le bilan est-il confidentiel ?",
    a: "Absolument. Le contenu de votre bilan est strictement confidentiel. Seul vous recevez le document de synthèse final, et aucune information n'est communiquée à votre employeur sans votre accord.",
  },
  {
    q: "Puis-je faire mon bilan entièrement en ligne ?",
    a: "Oui, E-forma propose un accompagnement 100% en ligne via visioconférence. Vous pouvez réaliser l'ensemble du parcours depuis chez vous, avec la même qualité d'accompagnement qu'en présentiel.",
  },
  {
    q: "Que se passe-t-il après le bilan ?",
    a: "À l'issue du bilan, vous disposez d'une synthèse complète avec un plan d'action concret. Votre consultant reste disponible pour un suivi post-bilan afin de vous accompagner dans la mise en œuvre de votre projet.",
  },
];

const FaqSection = () => (
  <section className="section-padding bg-muted/50">
    <div className="container mx-auto">
      <h2 className="mb-10 text-center text-3xl font-extrabold md:text-4xl">
        Vos Questions, Nos Réponses
      </h2>
      <div className="mx-auto max-w-3xl">
        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((faq, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              className="rounded-xl border border-border bg-card px-6 shadow-sm"
            >
              <AccordionTrigger className="text-left font-semibold hover:no-underline">
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground">
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  </section>
);

export default FaqSection;
